export default __webpack_public_path__ + "static/quote-slider-green-background-6a14b03be21b88e256013af3cad3fe67.webp";